import type { ReactElement } from 'react';
import type { LinkProps } from '@mui/material';
import { InlineLinkOrButton } from './InlineLinkOrButton';

export function LearnMoreButton({ children = 'Learn more.', ...rest }: LinkProps): ReactElement {
  return <InlineLinkOrButton {...rest}>{children}</InlineLinkOrButton>;
}
